import React from 'react';
import { useLoaderData } from 'react-router-dom';

const FriendDetail = () => {
    const friend = useLoaderData()
    const {name, email, phone, website} = friend;
  
    return (
        <div>
            <h1>this page is about {name}</h1>

            <div>
                <h4>{name}</h4>
                <p>{email}</p>
                <p>phone: {phone}</p>
                <p>Website: {website}</p>
            </div>
        </div>
    );
};

export default FriendDetail;